import { AiPromptIcon } from '../../shared/AiPromptIcon'
import { useMessages } from '@/i18n'
import { messages } from './sidebarMessages'

/**
 * AI-панель для бета-авторов (без права публиковать в каталог): пока закрыта.
 * Временная мера по решению заказчика — сервер AI-запуски не запрещает, поэтому
 * это именно заглушка в интерфейсе, а не проверка прав.
 */
export const AiUnavailableNotice = () => {
  const m = useMessages(messages)
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3 px-8 text-center">
      <AiPromptIcon className="size-10" />
      <p className="text-base font-medium text-foreground">{m.aiUnavailable}</p>
      <p className="text-sm text-muted-foreground">{m.aiUnavailableHint}</p>
    </div>
  )
}
